





























































import Vue from 'vue'
import { YPayBoxElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'YPayBoxEl',
  data: () => ({
    selected: false
  }),
  props: {
    templateItemData: {
      type: Object as () => YPayBoxElInterface,
      required: true
    },
    switchVisibility: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    downloadPdfBill (): void {
      if (Object.prototype.hasOwnProperty.call(this.templateItemData, 'pdfUri')) {
        window.open(this.templateItemData.pdfUri, '_blank')
      }
    },
    switchAction (): void {
      let active = this.$store.getters.getBillValues

      if (this.selected) {
        active.push(this.templateItemData.getValue)
      } else {
        active = active.filter((e: string) => e !== this.templateItemData.getValue)
      }

      this.$store.dispatch('commitBillValues', active)
    }
  }
})
